import { MegacablePlan } from '../models/megacable-plan.model';
import {
  getPlanPromoSocialNetworks,
  PLAN_PROMO_DEFAULT_CTA
} from '../constants/megacable-plan-promo.constants';
import { MobilePlanPromo } from '../models/mobile-plan-promo.model';

export class MegacablePlanMapper {

  static toMobilePlanPromos(plans: MegacablePlan[]): MobilePlanPromo[] {
    return [...plans]
      .sort((a, b) => a.monthlyPrice - b.monthlyPrice)
      .map((plan, index) => MegacablePlanMapper.toMobilePlanPromo(plan, index));
  }

  static toMobilePlanPromo(plan: MegacablePlan, index: number): MobilePlanPromo {
    return {
      id: plan.planId,
      title: plan.name,
      subtitle: plan.description,
      priceLabel: MegacablePlanMapper.formatMonthlyPrice(plan.monthlyPrice),
      monthlyPrice: plan.monthlyPrice,
      ctaLabel: PLAN_PROMO_DEFAULT_CTA,
      socialNetworks: getPlanPromoSocialNetworks(plan.monthlyPrice, index),
      simType: plan.simType || undefined
    };
  }

  private static formatMonthlyPrice(monthlyPrice: number): string {
    const amount = Math.trunc(monthlyPrice);
    return `$${new Intl.NumberFormat('es-MX', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount)}`;
  }
}
